import React, { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";
import { useCrm } from "../../pages/crm/CrmApp";
import { inputCls, Labeled } from "../market/admin/ui";

const localNow = (h = 1) => {
  const d = new Date(Date.now() + h * 3600e3);
  d.setMinutes(0, 0, 0);
  return new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, 16);
};

export const ReminderDialog = ({ open, onClose, onSaved, contact }) => {
  const { api } = useCrm();
  const [text, setText] = useState("");
  const [due, setDue] = useState(localNow());
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  useEffect(() => {
    if (open) {
      setText(contact ? `Dar seguimiento a ${contact.name}` : "");
      setDue(localNow());
      setErr("");
    }
  }, [open, contact]);
  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api("/reminders", { method: "POST", body: { text, contact_id: contact?.id || null, due_at: new Date(due).toISOString() } });
      onSaved?.();
      onClose();
    } catch (e2) {
      setErr(e2.message);
    } finally {
      setBusy(false);
    }
  };
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-sm rounded-2xl" data-testid="crm-reminder-dialog">
        <DialogHeader><DialogTitle>Nuevo recordatorio</DialogTitle></DialogHeader>
        <form onSubmit={save} className="space-y-3">
          <Labeled label="¿Qué hay que hacer?"><input required className={inputCls} value={text} onChange={(e) => setText(e.target.value)} data-testid="crm-reminder-text" /></Labeled>
          <Labeled label="Fecha y hora"><input required type="datetime-local" className={inputCls} value={due} onChange={(e) => setDue(e.target.value)} data-testid="crm-reminder-due" /></Labeled>
          <div className="flex flex-wrap gap-2">
            {[["En 1 h", 1], ["Mañana", 24], ["En 3 días", 72], ["En 1 semana", 168]].map(([l, h]) => (
              <button type="button" key={l} onClick={() => setDue(localNow(h))} className="rounded-full border border-slate-200 px-3 py-1 text-xs text-slate-600">{l}</button>
            ))}
          </div>
          {err && <p className="text-sm text-red-600">{err}</p>}
          <button disabled={busy} className="flex w-full items-center justify-center gap-2 rounded-xl py-3 text-sm font-semibold text-white" style={{ background: "var(--crm)" }} data-testid="crm-reminder-save">
            {busy && <Loader2 className="h-4 w-4 animate-spin" />} Guardar
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
